export const formatMoney = (value?: number | null) => {
  if (value === undefined || value === null) return ''
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value)
}

export const formatPercentage = (value?: number | null) => {
  if (value === undefined || value === null) return ''
  return new Intl.NumberFormat('en-US', {
    style: 'percent',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(value / 100)
}

// EMR can return MySQL zero-dates (e.g. "0000-00-00") for missing values
const ZERO_DATE_REGEX = /^0{4}-0{2}-0{2}/

// Returns '' for anything that is not a real parseable date (empty, zero-date, garbage)
export const normalizeDateString = (date?: string | null): string => {
  if (!date || ZERO_DATE_REGEX.test(date)) return ''
  if (Number.isNaN(new Date(date).getTime())) return ''
  return date
}

export const formatDate = (date: Date | string, options: Intl.DateTimeFormatOptions = {}) => {
  try {
    if (!date) return 'N/A'
    const parsedDate = typeof date === 'string' ? new Date(normalizeDateString(date)) : date
    if (Number.isNaN(parsedDate.getTime())) return 'N/A'
    return new Intl.DateTimeFormat('en-US', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      ...options,
    }).format(parsedDate)
  } catch {
    return 'N/A'
  }
}
